import http from '@/api/HttpHelper'
import { saveAs } from 'file-saver'
import moment from 'moment'

const findYears = function () {
    const startYear = 2016
    const yearNow = moment().year()
    const years = []

    for (let year = yearNow; year >= startYear; year--) {
        years.push(year)
    }

    return years
}

const findMonths = function (year) {
    if (year == moment().year()) {
        var currentMonth = moment().month()
        let months = []

        for (let month = currentMonth; month >= 0; month--) {
            const date = new Date(year, month, 1)
            months.push({name: moment(date).format("MMMM"), value: month})
        }

        return months

    } else {
        let months = []
        for (let month = 11; month >= 0; month--) {
            const date = new Date(year, month, 1)
            months.push({name: moment(date).format("MMMM"), value: month})
        }

        return months
    }
}

const state = {
    data: [],
    merchants: [],
    sum: 0,
    selectedMerchant: '',
    years: findYears(),
    months: findMonths(moment().year()),
    selectedYear: moment().year(),
    selectedMonth: null,
    branch: localStorage.getItem('branch') || '',
    loading: false
}

const getters = {
    loading (state) {
        return state.loading
    },
    data (state) {
        return state.data
    },
    merchants (state) {
        return state.merchants
    },
    sum (state) {
        return state.sum
    },
    branch (state) {
        return state.branch
    },
    selectedMerchant (state) {
        return state.selectedMerchant
    },
    years (state) {
        return state.years
    },
    months (state) {
        return state.months
    },
    selectedYear (state) {
        return state.selectedYear
    },
    selectedMonth (state) {
        return state.selectedMonth
    }
}

const mutations = {
    setLoading (state, isLoading) {
        state.loading = isLoading
    },
    selectedMerchant (state, selectedMerchant) {
        state.selectedMerchant = selectedMerchant
    },
    data (state, data) {
        state.data = data
    },
    merchants (state, merchants) {
        state.merchants = merchants
    },
    sum (state, sum) {
        state.sum = sum
    },
    setBranch (state, branch) {
        state.branch = branch
        localStorage.setItem('branch', branch)
    },
    setSelectedYear (state, year) {
        state.selectedYear = year
    },
    setSelectedMonth (state, month) {
        if (month === -2)
            state.selectedMonth = state.months[0]

        else if (month === -1)
            state.selectedMonth = {name:'Hele året', value:-1}
    
        else
            state.selectedMonth = month
    },
    refreshMonthSelection (state) {
        state.months = findMonths(state.selectedYear)
    }

}

const actions = {
    async getReportData ({ commit, state }) {
        commit('setLoading', true)
        const params = {
            year: state.selectedYear,
            month: state.selectedMonth.value + 1,
            merchant: state.selectedMerchant,
            branch: state.branch
        }
        const result = await http.get('breakage', {params: params})

        if (result.status == 200) {
            const { lines, sumBreakageAmount, merchants } = result.data
            commit('data', lines)
            commit('sum', sumBreakageAmount)

            if (!params.report && !params.merchant) {
                commit('merchants', merchants)
            }
        }
        commit('setLoading', false)
    },
    async getReportFile () {
        const params = {
            year: state.selectedYear,
            month: state.selectedMonth.value + 1,
            merchant: state.selectedMerchant,
            branch: state.branch
        }
        const result = await http.get('breakage/export', {params: params, responseType: 'blob'})

        if (result.status === 200)
            saveAs(result.data, 'breakage.xlsx')
    },
    setSelectedMerchant ({ commit, dispatch }, selectedMerchant) {
        commit('selectedMerchant', selectedMerchant)
        dispatch('getReportData')
    },
    setBranch ({ commit, dispatch }, branch) {
        commit('setBranch', branch)
        dispatch('getReportData')
    },
    setSelectedYear ({commit,dispatch}, year) {
        commit('setSelectedYear', year)
        commit('refreshMonthSelection')
        dispatch('getReportData')
    },
    setSelectedMonth ({commit,dispatch}, month) {
        commit('setSelectedMonth', month)
        dispatch('getReportData')
    },
    setSelectedMonthDefault ({commit}) {
        commit('setSelectedMonth', -2)
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}